module.exports = __webpack_public_path__ + "static/media/scout-icon.baa85495.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/scout-icon.svg
// module id = 524
// module chunks = 0